import { Colors } from './../../styles'
import styled from 'styled-components'
import { Form } from 'formik'
import { CircularProgress } from '@material-ui/core'
import TextFieldField from '../../components/Fields/TextFieldField/TextFieldField'

export const FlexForm = styled(Form)`
  display: flex;
  width: 60%;
  flex-direction: column;
  align-items: flex-start;
  color: ${Colors.GREY[200]};

  @media (max-width: 600px) {
    width: 90%;
  }

  .MuiFormControl-root {
    border: 2px solid ${Colors.GREY[400]};
    border-radius: 12px;
    input,
    textarea,
    select {
      color: ${Colors.GREY[200]};
    }
  }
  .MuiFormLabel-root {
    color: ${Colors.GREY[200]};
    .fieldset {
      display: none;
    }
  }
`

export const LoadingCircle = styled(CircularProgress)`
  margin-left: 12px;
`

export const SubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;

  .MuiButton-root {
    color: ${Colors.TEXT_DARK};
  }
`

export const SubmitSelectWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`

export const SubtitleInput = styled(TextFieldField)`
  font-family: Inter;
  color: ${Colors.GREY[200]};
`

export const InputWrapper = styled.div`
  width: 100%;
  color: ${Colors.GREY[200]};
`

export const TextLabel = styled.div`
  margin: 8px 0;
`

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${Colors.GREY[200]};
`

export const InfoLabel = styled.div`
  margin-right: 12px;
  color: ${Colors.GREY[400]};
`

export const LastAutoSave = styled.div`
  margin: 13px 22px;
  color: #8f8f8f;
  font-size: 0.7rem;
`

export const StyledLabel = styled.label.attrs(
  (props: { darkMode?: boolean; borderless?: boolean }) => props,
)`
  font-weight: 300;
  font-size: 1rem;
  margin-bottom: 6px;
  font-family: Inter;
  color: ${Colors.GREY[400]};

  &.MuiFormLabel-root {
    font-family: Inter;
  }
`
